import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["value"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["value"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.value === '...')
    ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
        _createElementVNode("button", {
          class: "btn",
          disabled: "",
          value: _ctx.value
        }, _toDisplayString(_ctx.value), 9, _hoisted_2)
      ]))
    : (_ctx.value===_ctx.selectedValue)
      ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-active",
            value: _ctx.value
          }, _toDisplayString(_ctx.value), 9, _hoisted_4)
        ]))
      : (_openBlock(), _createElementBlock("li", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn",
            value: _ctx.value
          }, _toDisplayString(_ctx.value), 9, _hoisted_6)
        ]))
}